import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, HeartPulse } from "lucide-react";
import { SITE } from "@/lib/content";

export const SiteFooter = () => (
  <footer className="border-t border-[#E2DACD] bg-[#1E2723] text-[#E6DEC3]">
    <div className="mx-auto grid max-w-6xl gap-10 px-5 py-14 sm:px-8 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-3">
          <img src="/images/logo-badge.png" alt="Brian Boland Psychotherapy — Where you are heard" className="h-12 w-12 rounded-full bg-white p-0.5" />
          <span className="font-serif text-lg font-semibold text-[#FAF7F2]">Brian Boland</span>
        </div>
        <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#B9C4BD]">
          Warm, confidential psychotherapy and counselling for adults — in person in {SITE.location} and online worldwide.
        </p>
      </div>
      <div>
        <h3 className="eyebrow !text-[#8FA99B]">Explore</h3>
        <ul className="mt-4 space-y-2.5 text-sm">
          <li><Link data-testid="footer-link-about" to="/about" className="transition-colors hover:text-[#FAF7F2]">About Brian</Link></li>
          <li><Link data-testid="footer-link-therapy" to="/therapy" className="transition-colors hover:text-[#FAF7F2]">Therapy & Counselling</Link></li>
          <li><Link data-testid="footer-link-fees" to="/fees-faq" className="transition-colors hover:text-[#FAF7F2]">Fees & FAQ</Link></li>
          <li><Link data-testid="footer-link-booking" to="/booking" className="transition-colors hover:text-[#FAF7F2]">Book & Contact</Link></li>
          <li><Link data-testid="footer-link-pay" to="/pay" className="transition-colors hover:text-[#FAF7F2]">Pay for a Session</Link></li>
          <li><Link data-testid="footer-link-privacy" to="/privacy" className="transition-colors hover:text-[#FAF7F2]">Privacy & Confidentiality</Link></li>
          <li><Link data-testid="footer-link-accessibility" to="/accessibility" className="transition-colors hover:text-[#FAF7F2]">Accessibility</Link></li>
        </ul>
      </div>
      <div>
        <h3 className="eyebrow !text-[#8FA99B]">Contact</h3>
        <ul className="mt-4 space-y-2.5 text-sm">
          <li className="flex items-center gap-2.5"><Phone size={15} className="text-[#B85C43]" /><a data-testid="footer-phone" href={`tel:${SITE.phone.replace(/\s/g, "")}`} className="hover:text-[#FAF7F2]">{SITE.phone}</a></li>
          <li className="flex items-center gap-2.5"><Mail size={15} className="text-[#B85C43]" /><a data-testid="footer-email" href={`mailto:${SITE.email}`} className="hover:text-[#FAF7F2]">{SITE.email}</a></li>
          <li className="flex items-start gap-2.5"><MapPin size={15} className="mt-0.5 text-[#B85C43]" /><span>{SITE.address}</span></li>
        </ul>
        <div className="mt-6 flex gap-3 rounded-2xl border border-[#3E4A43] bg-[#26312B] p-4">
          <HeartPulse size={18} className="mt-0.5 shrink-0 text-[#B85C43]" />
          <p className="text-xs leading-relaxed text-[#B9C4BD]">
            In crisis? This is not an emergency service. Call Samaritans free on <strong className="text-[#FAF7F2]">116 123</strong> (24/7) or emergency services on <strong className="text-[#FAF7F2]">112 / 999</strong>.
          </p>
        </div>
      </div>
    </div>
    <div className="border-t border-[#3E4A43] py-5 text-center text-xs text-[#7E8E85]">
      © {new Date().getFullYear()} Brian Boland Psychotherapy & Counselling. All rights reserved.{" "}
      <Link to="/admin" data-testid="footer-link-admin" className="transition-colors hover:text-[#B9C4BD]">Admin</Link>
    </div>
  </footer>
);
